import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function BodyTypeChips() {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      type="chips"
      name="type"
      isDeselectable
      label={i18n.t('entity.vehicle.labels.vehicleType')}
      options={catalogueApi?.vehicleTypeOptions ?? []}
    />
  );
}
